// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid'
import {
    Autocomplete,
    CardContent,
    Divider,
    FormControl,
    TextField,
    Typography,
} from '@mui/material'
import { useSearchParams } from "react-router-dom"
import axios from 'axios'

import Icon from '../../../components/icon'
import apiUrl from '../../../configs/constant'
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto'

import moment from 'moment'
import { useToast } from '../../../components/ToastProvider'
import Swal from "sweetalert2"
import Button from '@mui/material/Button'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast } = useToast()

    const [searchParams] = useSearchParams()

    // ? INIT DARI URL (sekali saja)
    const initTglAwal = searchParams.get('tglAwal') || moment().format('YYYY-MM-DD')
    const initTglAkhir = searchParams.get('tglAkhir') || moment().format('YYYY-MM-DD')
    const initProfitCenter = searchParams.get('profitCenter')

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(initTglAwal)
    const [tglAkhir, setTglAkhir] = useState<string>(initTglAkhir)

    const [valProfitCenter, setValProfitCenter] = useState<any>(null)
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])
    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getProfitCenter()
    }, [])

    const getProfitCenter = async () => {
        setListProfitCenter([])
        let url = apiUrl.apiUrl + '/acc/penyesuaian/list-profit-center'

        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListProfitCenter(data)

                    if (initProfitCenter) {
                        const found = data.find((e: any) => e.id == initProfitCenter)
                        if (found) {
                            setValProfitCenter(found)

                            // auto load
                            getData(found.id)
                        }
                    }
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getData = async (profitCenterId?: any) => {
        const id = profitCenterId || valProfitCenter?.id

        if (!id) {
            showToast('Profit Center belum dipilih', 'error')
            return
        }

        Swal.fire({
            title: 'Now loading',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        })

        try {
            let url = apiUrl.apiUrl + '/acc/saldo-karyawan/list'

            const response = await axios.get(url, {
                params: {
                    accprofitcenter_id: id,
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir,
                },
                headers: { Authorization: `Bearer ${token}` }
            })

            if (response.data.success) {
                const data = response.data.data
                setListData(data)
            } else {
                showToast(response.data.message, 'error')
            }

        } catch (err) {
            showToast('Terjadi kesalahan', 'error')
        } finally {
            Swal.close()
        }
    }

    const handleChangeProfitCenter = (event: SyntheticEvent, newValue: any | null) => {
        setValProfitCenter(newValue)
    }

    const convertComponent = [
        {
            key: 'dokumen',
            renderCell: ({ row }: any) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => window.open(row.data.link_dokumen, '_blank')}
                    >
                        <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                            {row.data.dokumen}
                        </Typography>
                    </div>
                </Box>
            )
        },
    ]

    return (
        <Grid container spacing={3} justifyContent='center'>
            <Grid item xs={12}>
                <div className='content-block dx-card'>
                    <CardHeader title='SALDO KARYAWAN' />
                    <Divider />

                    <CardContent>
                        <Grid container spacing={5}>

                            {/* Tanggal */}
                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label='Tanggal Awal'
                                    type='date'
                                    value={tglAwal}
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label='Tanggal Akhir'
                                    type='date'
                                    value={tglAkhir}
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            {/* Profit Center */}
                            <Grid item xs={12} md={4}>
                                <Autocomplete
                                    value={valProfitCenter}
                                    options={listProfitCenter}
                                    isOptionEqualToValue={(o, v) => o.id === v.id}
                                    getOptionLabel={(o) => o.nama_profitcenter}
                                    onChange={handleChangeProfitCenter}
                                    renderInput={(params) => (
                                        <TextField {...params} label='Profit Center' />
                                    )}
                                />
                            </Grid>

                            {/* Button */}
                            <Grid item xs={12} md={2}>
                                <Button
                                    fullWidth
                                    variant='contained'
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData()}
                                    disabled={!valProfitCenter}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>

                        <MsiDatagrid
                            array={listData}
                            convertRupiah={['debet', 'kredit']}
                            hiddenColumns={['link_dokumen', 'id']}
                            customRender={convertComponent}
                        />
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}